<template>
  <div>
    <AddSchoolModal v-show="showModal" @close="showModal = false"></AddSchoolModal>
    <h1>Schulen</h1>
    <ul>
      <li v-for="school in schools" :key="school.$id">
        <router-link v-bind:to="/schule/ + school.$id" class="nav-link">{{ school.name }} - {{ school.address }}</router-link>
      </li>
    </ul>
    <button class="default-button" @click="showModal = true">Schule Hinzufügen</button>
  </div>
</template>

<script>
import { fetchSchools } from "../firebase/firebase";
import AddSchoolModal from "../components/AddSchoolModal";

export default {
  components:{
    AddSchoolModal
  },
  name: "schools",
  methods:{

  },
  data() {
    return {
      schools: [],
      unsubscribe: null,
      showModal: false,
      name: "",
      address: ""
    };
  },
  created() {
    this.unsubscribe = fetchSchools().onSnapshot(querySnapshot => {
      this.schools = querySnapshot.docs.map(doc => {
        const $data = doc.data();
        return {
          $id: doc.id,
          ...$data
        };
      });
    });
  },
  destroyed() {
    if(this.unsubscribe){
      this.unsubscribe()
    }
  }
};
</script>